import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase';

export function useCases(userId) {
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(Boolean(userId));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!userId) {
            setLoading(false);
            setCases([]);
            return undefined;
        }
        setLoading(true);
        setError(null);
        const ref = collection(db, 'users', userId, 'cases');
        const unsubscribe = onSnapshot(
            ref,
            (snapshot) => {
                const next = [];
                snapshot.forEach((doc) => {
                    next.push({ id: doc.id, ...doc.data() });
                });
                setCases(next);
                setLoading(false);
            },
            (err) => {
                setError(err);
                setLoading(false);
            }
        );
        return unsubscribe;
    }, [userId]);

    return { cases, loading, error };
}
